import styled from "styled-components";
import { GameJackpotValueSIBox } from "./game-jackpot-value.si.box";

export const GameJackpotValueSICisBox = styled(GameJackpotValueSIBox)`
    letter-spacing: 0.44px;
`;